import React from 'react'
import { InfoIcon } from '@shared/assets/icons'
import { Text } from '@shared/ui/atoms'
import NewAccountsIntructionButton from '../ui/new-accounts-instruction/NewAccountsIntructionButton'
import RegionsWithRestrictionsIntructionButton from '../ui/regions-with-restrictions-instruction/RegionsWithRestrictionsIntructionButton'
import ScrollToSteamVouchersButton from '../ui/ScrollToSteamVouchersButton'

export const importantSectionItems = [
  {
    icon: <InfoIcon />,
    content: (
      <Text family="MTSCompact" size="pM" weight="medium" color="secondary">
        Для успешной оплаты рекомендуем использовать IP-адрес России
      </Text>
    ),
  },
  {
    icon: <InfoIcon />,
    content: (
      <Text family="MTSCompact" size="pM" weight="medium" color="secondary">
        Инструкция для <NewAccountsIntructionButton />{' '}
        <span style={{ whiteSpace: 'nowrap' }}>
          и <RegionsWithRestrictionsIntructionButton />
        </span>{' '}
        (Крым, ЛНР, ДНР)
      </Text>
    ),
  },
  {
    icon: <InfoIcon />,
    content: (
      <Text family="MTSCompact" size="pM" weight="medium" color="secondary">
        Если регион отличается воспользуйтесь{' '}
        <ScrollToSteamVouchersButton>картами оплаты Steam</ScrollToSteamVouchersButton>
      </Text>
    ),
  },
]

export const faqSectionItems = [
  {
    title: 'Где найти логин',
    content: (
      <>
        Логин — это то, что вы указываете при входе в Steam. Если вы укажите неверный логин, то средства уйдут другому
        пользователю. Перейти к аккаунту
      </>
    ),
  },
  {
    title: 'Аккаунты Steam каких стран можно пополнить?',
    content: <>Аккаунты Steam каких стран можно пополнить?</>,
  },
  {
    title: 'Как пополнить новый аккаунт Steam?',
    content: <>Как пополнить новый аккаунт Steam?</>,
  },
]
